module.exports = __webpack_public_path__ + "static/media/portfolio_site_invisible_cities_1.be99b0ad.png";